import axios from "axios";
import { SendMemberRequest, MemberResponse, UpdateCorporateManagementRoleRequest, UpdateCorporateMemberRequest } from "./dto/CorporateMember";

/**
 * メンバー招待メール送信
 */
export const sendMemberRegister = async (
  req: SendMemberRequest
): Promise<void> => {
  await axios.post<SendMemberRequest>("/api/corporation/user/reception", req, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};

/**
 * メンバー一覧取得
 */
export const getMembers = async (): Promise<MemberResponse[]> => {
  const res = await axios.get<MemberResponse[]>(`/api/corporation/member/list`);
  return res.data;
};

/**
 * 管理者権限を更新
 */
export const updateCorporationManagementRole = async (req: UpdateCorporateManagementRoleRequest): Promise<MemberResponse[]> => {
  const res = await axios.put<MemberResponse[]>("/api/corporation/user/role", req, {
  headers: {
     "Content-Type": "application/json;charset=utf-8",
  }});
  return res.data;
};

/**
 * 参加プロジェクト編集
 */
export const updateJoinProject = async (id: string, req: UpdateCorporateMemberRequest): Promise<MemberResponse[]> => {
  const res = await axios.put<MemberResponse[]>(`/api/corporation/user/project?id=${id}`, req, {
  headers: {
     "Content-Type": "application/json;charset=utf-8",
  }});
  return res.data;
};

/**
 * メンバー削除
 */
export const deleteMember = async (id: string): Promise<void> => {
  await axios.delete<void>(`/api/corporation/user?id=${id}`);
};